import { render } from "./GoalKROwnerActivity.vue?vue&type=template&id=36a5fd0e"
import script from "./GoalKROwnerActivity.vue?vue&type=script&lang=js"
export * from "./GoalKROwnerActivity.vue?vue&type=script&lang=js"
script.render = render

export default script